import { useMutation, useQueryClient } from '@tanstack/react-query'
import { AdminConsoleOrgsApi } from '@portal/pkg-api/admin-console'
import type {
  CreateOrganizationRequest,
  UpdateOrganizationRequest,
} from '@portal/pkg-api/gen/admin-console'
import { data } from '@portal/pkg-api/helpers'
import { OrganizationQueries } from './queries'

const prefix = 'admin-console.organization'

export const OrganizationMutations = {
  create: () => ({
    mutationKey: [prefix, 'create'],
    mutationFn: (request: CreateOrganizationRequest) =>
      data(AdminConsoleOrgsApi.createOrganization(request, { mercatusNotifyOnError: false })),
  }),
  update: () => ({
    mutationKey: [prefix, 'update'],
    mutationFn: ({ id, ...request }: { id: number } & UpdateOrganizationRequest) =>
      data(AdminConsoleOrgsApi.updateOrganization(id, request, { mercatusNotifyOnError: false })),
  }),
}

export function useCreateOrg() {
  const queryClient = useQueryClient()

  return useMutation({
    ...OrganizationMutations.create(),
    onSuccess: () => {
      void queryClient.invalidateQueries(OrganizationQueries.list())
    },
  })
}

export function useUpdateOrg() {
  const queryClient = useQueryClient()

  return useMutation({
    ...OrganizationMutations.update(),
    onSuccess: (_result, { id }) => {
      void queryClient.invalidateQueries(OrganizationQueries.list())
      void queryClient.invalidateQueries(OrganizationQueries.details(id))
    },
  })
}
